import mutationsTypes from '@/vuex/administracao/edicao-tipo-documental/mutations-types.js'
const types = {
  ...mutationsTypes,
  BUSCA_TIPOS_DOCUMENTAIS: 'BUSCA_TIPOS_DOCUMENTAIS',
  SELECIONA_TIPO_DOCUMENTAL: 'SELECIONA_TIPO_DOCUMENTAL',
  ALTERA_PROPRIEDADE_TIPO_DOCUMENTAL: 'ALTERA_PROPRIEDADE_TIPO_DOCUMENTAL'
}

export default types
